import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { styled } from '@mui/material/styles';
// import CloseIcon from '@mui/icons-material/Close';

import { closeModal } from "../../store";
import ConfirmModal from "./ConfirmModal";
import ConfirmStaffModal from "./ConfirmStaffModal";
import MedicationFilterModal from "./MedicationFilterModal";
import EditProfileModal from "./EditProfileModal";
import EditPatientDetailModal from "./EditPatientDetailModal";
import ResetPasswordModal from "./ResetPasswordModal";
import ResetPasswordConfirmModal from "./ResetPasswordConfirmModal";
import SignUpSuccessModal from "./SignUpSuccessModal";
import BrainMemoryConsentModal from "./BrainMemoryConsentModal";
import ReportVideoSummaryModal from "./ReportVideoSummaryModal";
import GuidanceLevelsModal from './GuidanceLevelsModal'
import ChangeLogModal from './ChangeLogModal';
import PdfViewerModal from './PdfViewerModal';
import OpenExternalModal from "./OpenExternalModal";
import OrderKitModal from "./OrderKitModal";
import AddPatientModal from "./AddPatientModal";
import PendingPatientDetailModal from "./PendingPatientDetailModal";

const Wrapper = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(127 127 127 / 34%);
  mix-blend-mode: normal;
  backdrop-filter: blur(7.5px);
  z-index: 300;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: hidden;
`;

const ModalContainer = styled('div')(({ theme }) => ({
  background: 'transparent',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    borderRadius: '20px',
    overflowY: 'scroll',
  },
  [theme.breakpoints.up('sm')]: {
    height: 'auto',
  }
}))

// const useOutsideAlerter = (ref) => {
//   const dispatch = useDispatch();
//   const handleClickOutside = (e) => {
//     if (ref.current && !ref.current.contains(e.target)) {
//       dispatch(closeModal());
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   });
// };

const Modal = () => {
  const dispatch = useDispatch();
  // const containerRef = useRef(null);
  const openModal = useSelector((state) => state.openModal);
  const currentModal = useSelector((state) => state.currentModal);
  const modalProps = useSelector((state) => state.modalProps);
  const parentWidthStyle = modalProps?.parentWidthStyle ?? { xs: '100%', sm: 'auto' }
  // useOutsideAlerter(containerRef);
  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  useEffect(() => {
    if (!openModal) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleCloseModal();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [openModal]); // eslint-disable-line react-hooks/exhaustive-deps

  const renderModal = () => {
    switch (currentModal) {
      case 'CONFIRM_MODAL':
        return <ConfirmModal close={handleCloseModal} data={modalProps} />;
      case 'CONFIRM_STAFF_MODAL':
        return <ConfirmStaffModal close={handleCloseModal} data={modalProps} />;
      case 'MEDICATION_FILTER_MODAL':
        return <MedicationFilterModal close={handleCloseModal} data={modalProps} />
      case 'EDIT_PROFILE_MODAL':
        return <EditProfileModal close={handleCloseModal} data={modalProps} />
      case 'EDIT_PATIENT_DETAIL_MODAL':
        return <EditPatientDetailModal close={handleCloseModal} data={modalProps} />
      case 'RESET_PASSWORD_MODAL':
        return <ResetPasswordModal close={handleCloseModal} data={modalProps} />
      case 'RESET_PASSWORD_CONFIRM_MODAL':
        return <ResetPasswordConfirmModal close={handleCloseModal} data={modalProps} />        
      case 'SIGN_UP_SUCCESS_MODAL':
        return <SignUpSuccessModal close={handleCloseModal} data={modalProps} />    
      case 'BRAIN_MEMORY_CONSENT_MODAL':
        return <BrainMemoryConsentModal close={handleCloseModal} data={modalProps} />    
      case 'GUIDANCE_LEVEL_MODAL':
        return <GuidanceLevelsModal close={handleCloseModal} data={modalProps} />
      case 'REPORT_VIDEO_SUMMARY':
        return <ReportVideoSummaryModal close={handleCloseModal} data={modalProps} /> 
      case 'CHANGELOG_MODAL':
        return <ChangeLogModal close={handleCloseModal} data={modalProps} />
      case 'PATIENT_DETAIL_PDF_MODAL':
        return <PdfViewerModal close={handleCloseModal} data={modalProps}/>
      case 'OPEN_EXTERNAL_MODAL':
        return <OpenExternalModal close={handleCloseModal} data={modalProps}/>
      case 'OPEN_ORDER_KITS_MODAL':
        return <OrderKitModal close={handleCloseModal} data={modalProps}/>
      case 'ADD_PATIENT_MODAL':
        return <AddPatientModal close={handleCloseModal} data={modalProps}/>
      case 'PENDING_PATIENT_DETAIL_MODAL':
        return <PendingPatientDetailModal close={handleCloseModal} data={modalProps}/>
      default:
        return null;
    }
  };

  if (!openModal) {
    return null;
  }

  return (
    <Wrapper onClick={handleCloseModal}>
      <Box position='relative' padding={{ xs: '20px', sm: '30px' }} width={parentWidthStyle} onClick={(e) => e.stopPropagation()}>
        <ModalContainer>{renderModal()}</ModalContainer>
        {/* <Box
          sx={{
            display: { xs: 'none', sm: 'block' },
            position: 'absolute',
            top: 0,
            right: 0,
            cursor: 'pointer'
          }}
          onClick={handleCloseModal}
        >
          <Box sx={{
            background: 'white',
            borderRadius: '50%',
            width: '34px',
            height: '34px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'primary.dark',
            transition: 'background 0.1s 0.1s, color 0.1s 0.1s',
            
            '&:hover': {
              background: '#284C88',
              color: 'white',
            }
          }}>
            <CloseIcon sx={{
              width: '22px',
              height: '22px'
            }} />
          </Box>
        </Box> */}
      </Box>
    </Wrapper>
  );
};

export default Modal;
